module.exports = __webpack_public_path__ + "../static/img/logo.f7686e58.svg";